/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
// import { KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useAuth } from '../../../../app/modules/auth'
import { checkIsAdministrator } from '../../../helpers/FunctionHelpers'

export function AsideMenuSupperAdmin() {
  const intl = useIntl();
  const { currentUser } = useAuth();
  const isAdministrator = checkIsAdministrator(currentUser);

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Quản lý khối</span>
        </div>
      </div>

      <AsideMenuItemWithSub
        to='/report-sale'
        title='Báo cáo doanh số'
        icon='/media/svg/custom/icn_revenue.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/report-sale/report-manager' title='Báo cáo quản lý' hasBullet={true} />
        <AsideMenuItem to='/report-sale/region-office' title='Vùng miền - văn phòng' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/report-deposit'
        title='Báo cáo Tiền nạp'
        icon='/media/svg/custom/icn_revenue.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/report-deposit/report-manager' title='Báo cáo quản lý' hasBullet={true} />
        <AsideMenuItem to='/report-deposit/region-office' title='Vùng miền - văn phòng' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/manage-client'
        title='Quản lý khách hàng'
        icon='/media/svg/custom/icn_partner.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/manage-client/report-new-client' title='Báo cáo số lượng KH mới' hasBullet={true} />
        <AsideMenuItem to='/manage-client/client-category' title='Danh mục khách hàng' hasBullet={true} />
      </AsideMenuItemWithSub>

      {/* <AsideMenuItem
        to='/sales'
        icon='/media/svg/custom/icn_revenue.svg'
        title='Doanh số'
        fontIcon='bi-layers'
      /> */}
      {/* <AsideMenuItem
        to='/partners'
        // icon='/media/icons/duotune/general/gen019.svg'
        icon='/media/svg/custom//icn_partner.svg'
        title='Đối tác'
        fontIcon='bi-layers'
      /> */}
      {/* <AsideMenuItem
        to='/installment-package'
        // icon='/media/icons/duotune/art/art002.svg'
        icon='/media/svg/custom//icn_poll.svg'
        title='Gói trả góp'
        fontIcon='bi-layers'
      /> */}
      <AsideMenuItemWithSub
        to='/account-management'
        title='Quản lý tài khoản'
        // icon='/media/icons/duotune/communication/com006.svg'
        icon='/media/svg/custom/icn_account.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/account-management/accounts' title='Quản lý tài khoản' hasBullet={true} />
        <AsideMenuItem to='/account-management/roles' title='Quản lý chức danh' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItem
        to='/region-management/regions'
        // icon='/media/icons/duotune/general/gen019.svg'
        icon='/media/svg/custom/icn_location.svg'
        title='Vùng miền - Văn phòng'
        fontIcon='bi-layers'
      />
      {/* {isAdministrator && <AsideMenuItem
        to='/training-management'
        // icon='/media/icons/duotune/general/gen019.svg'
        icon='/media/svg/custom/icn_location.svg'
        title='Quản lý đào tạo'
        fontIcon='bi-layers'
      />
      } */}
      {isAdministrator && <AsideMenuItem
        to='/shareholder/sharehoder-management'
        icon='/media/icons/duotune/general/gen019.svg'
        // icon='/media/svg/custom/icn_location.svg'
        title='Quản lý ký số'
        fontIcon='bi-layers'
      />
      }
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
    </>
  )
}
